import React from "react";
import { X, Calendar, Clock, Video } from "lucide-react";

export default function CoachingModal({ onClose }) {
  // Replace these with your actual Calendly / booking links
  const LINK_2_HOUR = "https://calendly.com/trapound-support/tradingview-2-hours";
  const LINK_1_HOUR = "https://calendly.com/trapound-support/tradingview-1-hour";

  return (
    <div className="fixed inset-0 z-[100] flex items-center justify-center bg-black/80 backdrop-blur-sm p-4">
      <div className="bg-gray-900 border border-gray-700 rounded-2xl shadow-2xl w-full max-w-2xl overflow-hidden relative">
        
        {/* Header */}
        <div className="flex justify-between items-center p-6 border-b border-gray-800">
          <div>
            <h2 className="text-2xl font-bold text-white flex items-center gap-2">
              <Video className="w-6 h-6 text-blue-500" />
              Book Your 1-on-1 Session
            </h2>
            <p className="text-gray-400 text-sm mt-1">
              You have 2 hours of coaching included. Choose how to schedule your time.
            </p>
          </div>
          <button 
            onClick={onClose}
            className="text-gray-500 hover:text-white transition-colors bg-gray-800 hover:bg-gray-700 p-2 rounded-full"
          >
            <X className="w-5 h-5" />
          </button>
        </div>

        {/* Options Container */}
        <div className="p-6 grid grid-cols-1 md:grid-cols-2 gap-6">
          
          {/* Option A: One 2-Hour Session */}
          <div className="bg-gray-800/50 border border-gray-700 rounded-xl p-6 flex flex-col hover:border-blue-500/50 transition-colors">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-blue-500/20 p-3 rounded-lg text-blue-400">
                <Clock className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold text-white">Deep Dive</h3>
            </div>
            <p className="text-gray-400 text-sm mb-6 flex-1">
              A comprehensive 2-hour session. Book 2 back to back 1-hour sessions. Best if you want to set up all your charts, templates, and automated alerts in a single sitting.
            </p>
            <div className="flex flex-col gap-3 mt-auto">
              <a 
                href={LINK_1_HOUR}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full text-center border border-blue-500/50 hover:bg-blue-600 hover:text-white text-blue-400 font-bold py-2 rounded-lg transition-colors flex items-center justify-center gap-2"
              >
                <Calendar className="w-4 h-4" />
                Book 1st Hour
              </a>
              <a 
                href={LINK_1_HOUR}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full text-center border border-gray-600 hover:bg-gray-700 text-gray-300 font-bold py-2 rounded-lg transition-colors flex items-center justify-center gap-2"
              >
                <Calendar className="w-4 h-4" />
                Book 2nd Hour
              </a>
          </div>
          </div>

          {/* Option B: Two 1-Hour Sessions */}
          <div className="bg-gray-800/50 border border-gray-700 rounded-xl p-6 flex flex-col hover:border-purple-500/50 transition-colors">
            <div className="flex items-center gap-3 mb-4">
              <div className="bg-purple-500/20 p-3 rounded-lg text-purple-400">
                <Clock className="w-6 h-6" />
              </div>
              <h3 className="text-xl font-bold text-white">Split Sessions</h3>
            </div>
            <p className="text-gray-400 text-sm mb-6 flex-1">
              Two separate 1-hour sessions. Best if you want to get the basics set up first, practice, and come back later for advanced alerts.
            </p>
            <div className="flex flex-col gap-3 mt-auto">
              <a 
                href={LINK_1_HOUR}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full text-center border border-purple-500/50 hover:bg-purple-600 hover:text-white text-purple-400 font-bold py-2 rounded-lg transition-colors flex items-center justify-center gap-2"
              >
                <Calendar className="w-4 h-4" />
                Book Session 1
              </a>
              <a 
                href={LINK_1_HOUR}
                target="_blank"
                rel="noopener noreferrer"
                className="w-full text-center border border-gray-600 hover:bg-gray-700 text-gray-300 font-bold py-2 rounded-lg transition-colors flex items-center justify-center gap-2"
              >
                <Calendar className="w-4 h-4" />
                Book Session 2
              </a>
            </div>
          </div>

        </div>
        
        <div className="p-4 bg-gray-800/80 border-t border-gray-800 text-center text-xs text-gray-500">
          Note: Sessions must be booked using the email address associated with your Trapound account.
        </div>
      </div>
    </div>
  );
}